/**
 * TikTok Pixel Event Tracking for E-commerce
 * Pixel ID: D70P1GRC77U0CH2O13G0
 */

// Check if TikTok Pixel is loaded
const isTikTokPixelLoaded = () => {
  return typeof window !== 'undefined' && window.ttq;
};

// Track page view
export const trackPageView = () => {
  if (isTikTokPixelLoaded()) {
    window.ttq.page();
  }
};

// Track product view
export const trackViewContent = (product) => {
  if (isTikTokPixelLoaded() && product) {
    window.ttq.track('ViewContent', {
      content_id: product.id || product._id,
      content_type: 'product',
      content_name: product.name,
      price: product.price,
      currency: 'USD'
    });
  }
};

// Track add to cart
export const trackAddToCart = (product, quantity = 1) => {
  if (isTikTokPixelLoaded() && product) {
    window.ttq.track('AddToCart', {
      content_id: product.id || product._id,
      content_type: 'product',
      content_name: product.name,
      quantity: quantity,
      price: product.price,
      value: product.price * quantity,
      currency: 'USD'
    });
  }
};

// Track initiate checkout
export const trackInitiateCheckout = (cart) => {
  if (isTikTokPixelLoaded() && cart) {
    window.ttq.track('InitiateCheckout', {
      content_type: 'product',
      contents: cart.items?.map(item => ({
        content_id: item.product_id,
        content_name: item.name,
        quantity: item.quantity,
        price: item.price
      })) || [],
      value: cart.total,
      currency: 'USD'
    });
  }
};

// Track purchase/complete payment
export const trackPurchase = (order) => {
  if (isTikTokPixelLoaded() && order) {
    window.ttq.track('CompletePayment', {
      content_type: 'product',
      contents: order.items?.map(item => ({
        content_id: item.product_id,
        content_name: item.name,
        quantity: item.quantity,
        price: item.price
      })) || [],
      value: order.total,
      currency: 'USD',
      order_id: order.id || order._id
    });
  }
};

// Track search
export const trackSearch = (query) => {
  if (isTikTokPixelLoaded() && query) {
    window.ttq.track('Search', {
      query: query
    });
  }
};

// Track registration
export const trackRegistration = () => {
  if (isTikTokPixelLoaded()) {
    window.ttq.track('CompleteRegistration');
  }
};

// Track add to wishlist
export const trackAddToWishlist = (product) => {
  if (isTikTokPixelLoaded() && product) {
    window.ttq.track('AddToWishlist', {
      content_id: product.id || product._id,
      content_name: product.name,
      price: product.price,
      currency: 'USD'
    });
  }
};

export default {
  trackPageView,
  trackViewContent,
  trackAddToCart,
  trackInitiateCheckout,
  trackPurchase,
  trackSearch,
  trackRegistration,
  trackAddToWishlist
};
